/* Buena Vita - product page behaviour.
   Gallery swap, quantity stepper, sticky add-to-cart, free-shipping nudge.
   Dependency-free so it can't break when the theme's own JS changes. */
(function () {
  'use strict';

  if (window.__bvProductInit) return;
  window.__bvProductInit = true;

  /* ---------- gallery ---------- */

  function initGallery(scope) {
    var galleries = (scope || document).querySelectorAll('[data-bv-gallery]');

    for (var i = 0; i < galleries.length; i++) {
      (function (gal) {
        if (gal.dataset.bvBound === '1') return;
        gal.dataset.bvBound = '1';

        var main = gal.querySelector('[data-bv-gallery-main] img');
        if (!main) return;

        gal.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-bv-thumb]');
          if (!thumb || !gal.contains(thumb)) return;

          var full = thumb.getAttribute('data-full');
          if (!full) return;

          // The main image is responsive; swapping src alone would leave the
          // old srcset in charge, so clear it and let src win.
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = full;

          var all = gal.querySelectorAll('[data-bv-thumb]');
          for (var j = 0; j < all.length; j++) {
            all[j].setAttribute('aria-current', all[j] === thumb ? 'true' : 'false');
          }
        });
      })(galleries[i]);
    }
  }

  /* ---------- quantity ---------- */

  function initQty(scope) {
    var buttons = (scope || document).querySelectorAll('[data-bv-qty]');

    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        if (btn.dataset.bvBound === '1') return;
        btn.dataset.bvBound = '1';

        btn.addEventListener('click', function () {
          var wrap = btn.closest('.bv-buy__qty');
          if (!wrap) return;

          var input = wrap.querySelector('[data-bv-qty-input]');
          if (!input) return;

          var step = parseInt(btn.getAttribute('data-bv-qty'), 10) || 0;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;

          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      })(buttons[i]);
    }
  }

  /* ---------- sticky add to cart ---------- */

  function initSticky(scope) {
    var bar = (scope || document).querySelector('[data-bv-sticky]');
    var anchor = (scope || document).querySelector('[data-bv-sticky-anchor]');
    if (!bar || !anchor) return;
    if (bar.dataset.bvBound === '1') return;
    bar.dataset.bvBound = '1';

    // The sticky button duplicates the main one. Keep the duplicate out of the
    // tab order and the accessibility tree while the real control is on screen,
    // so screen-reader users don't meet two identical "Add to cart" buttons.
    function setHidden(hidden) {
      bar.classList.toggle('is-in', !hidden);
      bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      var btn = bar.querySelector('button, a');
      if (btn) {
        if (hidden) {
          btn.setAttribute('tabindex', '-1');
        } else {
          btn.removeAttribute('tabindex');
        }
      }
    }

    setHidden(true);

    if (!('IntersectionObserver' in window)) {
      // No observer support: leave the bar off rather than pinned open. The
      // real buy button is always present, so nothing is lost.
      return;
    }

    var phone = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (phone && phone.matches) {
            // Phones (v14): the real button sits about two screens down, so
            // on the first screen this bar is the only way to buy. Show it
            // whenever the real one is off screen, above or below.
            setHidden(entry.isIntersecting);
            return;
          }
          // Desktop: show the bar only once the real add-to-cart has scrolled
          // away upward. Without the boundingClientRect check the bar would
          // also appear while the buy box is still below the fold on first
          // paint.
          var scrolledPast = entry.boundingClientRect.top < 0;
          setHidden(entry.isIntersecting || !scrolledPast);
        });
      },
      { rootMargin: '0px', threshold: 0 }
    );

    io.observe(anchor);
  }

  /* ---------- free shipping nudge ---------- */

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initShipping(scope) {
    var el = (scope || document).querySelector('[data-bv-ship]');
    if (!el) return;
    if (el.dataset.bvBound === '1') return;
    el.dataset.bvBound = '1';

    var thresholdCents = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    if (thresholdCents <= 0) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;

        // An empty cart gets nothing. "You're $70 away from free shipping"
        // before you've added anything reads as a demand, not an offer - the
        // static line in the buy box already states the threshold.
        if (total <= 0) return;

        var remaining = thresholdCents - total;
        var fill = el.querySelector('[data-bv-ship-fill]');
        var text = el.querySelector('[data-bv-ship-text]');

        if (remaining <= 0) {
          if (text) text.innerHTML = '<strong>Your order qualifies for free shipping.</strong>';
          if (fill) fill.style.width = '100%';
        } else {
          if (text) {
            text.innerHTML =
              "You're <strong>" + money(remaining) + '</strong> away from free shipping.';
          }
          if (fill) {
            var pct = Math.max(0, Math.min(100, (total / thresholdCents) * 100));
            fill.style.width = pct.toFixed(1) + '%';
          }
        }

        el.classList.add('is-on');
      })
      .catch(function () {
        // Cart unavailable: leave the nudge hidden. The static free-shipping
        // line in the buy box still tells them the threshold.
      });
  }

  /* ---------- boot ---------- */

  function init(scope) {
    initGallery(scope);
    initQty(scope);
    initSticky(scope);
    initShipping(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
